<template>
  <div class="site-map">
    <ul class="main-site-list" v-for="main of siteMapConfig" :key="main.label">
      <li class="main-site-list__item">
        <span class="main-site-list__item__label">
          {{ main.label }}
        </span>
        <ul class="sub-site-list">
          <li class="sub-site-list__item" v-for="sub of main.subList" :key="sub.label">
            <router-link :to="sub.route">
              <span class="sub-site-list__item__label">
                {{ sub.label }}
              </span>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { siteMapConfig } from '@/config/routeMappingConfig';

export default defineComponent({
  name: 'Sitemap',
  setup() {
    return {
      siteMapConfig,
    };
  },
});
</script>
<style lang="scss" scoped>
.site-map {
  @include flex(flex-start, flex-start);
}

.main-site-list {
  &:first-child {
    flex: none;
    width: 110px;
  }

  &:nth-child(2) {
    flex: none;
    width: 210px;
  }

  &:nth-child(3) {
    flex: none;
  }

  &:nth-child(4) {
    flex: none;
    width: 120px;
  }

  &:nth-child(5) {
    flex: none;
  }

  &:last-child {
    flex: none;
  }

  & + & {
    margin-left: 20px;
  }

  &__item {
    &__label {
      @include font-style($c-main, 16, 400, 1.6px);
    }
  }
}

.sub-site-list {
  margin-top: 25px;

  &__item {
    cursor: pointer;

    & + & {
      padding-top: 15px
    }

    &__label {

      @include font-style($c-white, $f-footer, 500, 1.4px, 24px);
    }
  }
}
</style>
